import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TextUnderlineHeading } from '../../Styles';
import { useNavigate } from 'react-router-dom';
import { OpenSwal } from '../../Utils';
import { LoadingButton } from '@mui/lab';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { NewRequestlist } from '../../Components/Interpreter/AssignmentsListscard';
import LinearProgress from '@mui/material/LinearProgress';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { url_fetch_assignment_lists } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';
import dayjs from 'dayjs';

const cardTheme = ({  //white theme
    colors: {
        text: '#ffffff',
        main: '#f2f2f2',
        dark: '#f2f2f2',
        contrastText: '#03070f',
    },
    cardborderRadius: '15px'
});

function sortAssignments(data) {
    if (!Array.isArray(data)) return data;
    const now = dayjs();
    return [...data].sort((a, b) => {
        const dateA = dayjs(a.assign_requestdatetime, 'MM/DD/YYYY hh:mm A').toDate();
        const dateB = dayjs(b.assign_requestdatetime, 'MM/DD/YYYY hh:mm A').toDate();
        return dateA - dateB;
    });
}

function AssignmentNewRequestList({ assign_id, PusherDashboardTrigger }) {

    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;

    const [newAssignmentRequestAry, newAssignmentRequestArySet] = useState([]);
    const [viewNewAssignmentRequestButtonSpin, viewNewAssignmentRequestButtonSpinSet] = useState(false);
    const [viewNewAssignmentRequestButton, viewNewAssignmentRequestButtonSet] = useState(null);
    const [axiosuseEffectstatus, axiosuseEffectstatuslimitset] = useState('limit');

    useEffect(() => {
        let payload = new FormData();
        payload.append('assign_status', 'inprogress');
        payload.append('skip_assign_id', assign_id);
        payload.append('status', axiosuseEffectstatus);
        apiWithAuth.post(url_fetch_assignment_lists, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                const sortedData = sortAssignments(response.data.data);
                newAssignmentRequestArySet(sortedData);
                if (response.data.data.length === 0) {
                    viewNewAssignmentRequestButtonSet('no_records');
                } else if (response.data.data.length >= 4) {
                    if (axiosuseEffectstatus === "limit") viewNewAssignmentRequestButtonSet('view_all_requests_button');
                    else if (axiosuseEffectstatus === "all") viewNewAssignmentRequestButtonSet('hide_all');
                } else if (response.data.data.length < 4) {
                    viewNewAssignmentRequestButtonSet('hide_all');
                }
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else OpenSwal('Axios_error', response.data.message);
        }).catch(response => OpenSwal('Axios_error', response.message));
    }, [viewNewAssignmentRequestButtonSpin, PusherDashboardTrigger]);

    const viewAllRequests = () => {
        axiosuseEffectstatuslimitset('all');
        viewNewAssignmentRequestButtonSpinSet(true);
    }

    return (
        <Box>
            <Box sx={{ mt: 2, mb: 8, ml: 0.5 }}>
                <Box>
                    <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={TextUnderlineHeading} >New Assignment Request</Typography>
                    {/* <Divider sx={{ backgroundColor: appThemeColor, height: "3.5px", width: { xs: '175px', sm: '175px', md: '218px' }, borderRadius: '10px', mt: '-2px' }} /> */}
                </Box>
                {viewNewAssignmentRequestButton === null && <Box sx={{ mt: 5, mb: 5, display: 'flex', justifyContent: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%', alignItems: 'center' }} /></Box>}
                {viewNewAssignmentRequestButton !== null && <Grid container spacing={{ xs: 1.5, sm: 2, md: 2 }} sx={{ mt: 1 }}>  {newAssignmentRequestAry.map((assign_data, index) => {
                    return (<NewRequestlist key={index} cardTheme={cardTheme} appThemeColor={appThemeColor} assign_data={assign_data} />);
                })} </Grid>}
                {viewNewAssignmentRequestButton === 'view_all_requests_button' && <Box sx={{ mt: 2, mb: 4 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                        <LoadingButton sx={{ color: appThemeColor, textTransform: 'none', fontWeight: 'bold' }} onClick={viewAllRequests} loading={viewNewAssignmentRequestButtonSpin} loadingPosition="end" endIcon={<KeyboardDoubleArrowDownIcon />}> View All Requests </LoadingButton> </Box>
                </Box>}
                {viewNewAssignmentRequestButton === 'no_records' && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 5 }}  > <Typography sx={{ color: appThemeColor }}>No Records Found..!</Typography></Box>}

            </Box>

        </Box>

    )
}

export default AssignmentNewRequestList